export class GetBucketAggregations {
    static readonly type = '[GetBucketAggregations]: action';
}



